import {useEffect, useState} from 'react'
import {useAuthStore} from '@/features/auth/store/store'
import {IMPERSONATION_DURATION_MS} from '@/features/auth/constants.ts'

const formatRemaining = (ms: number) => {
    const totalSeconds = Math.max(0, Math.round(ms / 1000))
    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60
    return `${minutes}:${String(seconds).padStart(2, '0')}`
}

/**
 * Ticking "MM:SS" time left on the active impersonated session, for the always-visible header indicator.
 * Separate from useImpersonationExpiryTimer: that hook owns the warning/auto-restore side effects and only
 * needs to run once at the app root, while this one re-renders every second wherever it's displayed.
 */
export const useImpersonationRemainingTime = () => {
    const impersonating = useAuthStore(state => state.impersonating)
    const impersonationStartedAt = useAuthStore(state => state.impersonationStartedAt)
    const [now, setNow] = useState(() => Date.now())

    useEffect(() => {
        if (!impersonating) return
        const interval = setInterval(() => setNow(Date.now()), 1000)
        return () => clearInterval(interval)
    }, [impersonating])

    if (!impersonating || !impersonationStartedAt) return null
    return formatRemaining(impersonationStartedAt + IMPERSONATION_DURATION_MS - now)
}
